import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top whenever the route (pathname) changes, so
// client-side navigations don't preserve the previous page's scroll offset.
// Hash links (e.g. /#pricing) are left alone so in-page anchors still work.
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
};
